<template>
  <div class="consult-embed">
    <AiConsultChat :embed="true" />
  </div>
</template>

<script>
import AiConsultChat from '../components/AiConsultChat.vue'

/**
 * AI 出海专业咨询 —— 内嵌版。
 * 仅包含问答功能，不带站点头部导航栏与底部，用于小程序 web-view 内嵌。
 * 路由 meta 已关闭 header / footer（见 router/index.js）。
 */
export default {
  name: 'AiConsultEmbed',
  components: {
    AiConsultChat
  }
}
</script>

<style scoped>
.consult-embed {
  height: 100%;
  background: var(--bg);
}
</style>
